export default __webpack_public_path__ + "static/media/notification.6070a61c.m4a";